module.exports = __webpack_public_path__ + "img/promotional_export_options.cb797294.png";